module.exports = __webpack_public_path__ + "img/pdf.b533c4ca.svg";